import React, { useEffect, useState, useContext } from "react";
import BlurryImage from "../Components/BlurryImage.component";
import { FirebaseContext } from "../admin/context/FirebaseContext";
import { collection, getDocs, query, limit } from "firebase/firestore";
import Skeleton from "@mui/material/Skeleton";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Link, NavLink } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { Helmet } from "react-helmet-async";
import "../styles/content.style.scss";
import "../styles/slider.style.scss";
import Logo from "../icons/slogo";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import "@splidejs/react-splide/css/core";
import SocialProofContainer from "../Components/socialProofContainer";

// ..
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 400, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
});

function Home() {
  const { db } = useContext(FirebaseContext);
  const categorieRef = collection(db, "categoriesProducts");
  const productsRef = collection(db, "products");
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const matches = useMediaQuery("(max-width:400px)");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(categorieRef);
        const categoryData = [];
        snapshot.docs.forEach((doc) => {
          categoryData.push({ id: doc.id, ...doc.data() });
        });
        setCategories(categoryData);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(productsRef, limit(3));
        const snapshot = await getDocs(q).then((docs) => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          return docs;
        });
        const productData = [];

        snapshot.forEach((doc) => {
          productData.push({ id: doc.id, ...doc.data() });
        });
        setProducts(productData);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.querySelector(link.getAttribute("href"));
        const scrollPosition = target.getBoundingClientRect().top - 80;

        window.scrollTo({
          top: scrollPosition + window.pageYOffset,
          behavior: "smooth",
        });
      });
    });
  }, []);
  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>Accueil | GI</title>
      </Helmet>
      <div className="App top-ctn">
        <div className="slider-ctn">
          <div className="ctn-info">
            <h1 data-aos="fade-up" data-aos-delay="200" className="main-title">
              Généralite <span className="title-anchor">Informatique</span>
            </h1>
            <p data-aos="zoom-in" data-aos-delay="550">
              ventes et installation des caméras vidéo
              surveillance,l'installation et maintenance réseau informatique
              ainsi que la maintenance des equipements informatique et la vente
              des fournitures de bureau
            </p>
            <div className="btn-ctn" data-aos="zoom-in" data-aos-delay="1000">
              <button className="btn-btn-link-flat">
                <Link to="/about">Voir Plus</Link>
              </button>
              <button className="btn-btn-link">
                <Link to="/contact">Nous Contactez</Link>
              </button>
            </div>
          </div>
          <div className="ctn-slider-elt">
            <Splide
              aria-label="Slider image"
              className="slider-elt"
              options={{
                type: "loop",
                Width: "100%",
                height: "400px",
                autoplay: true,
                arrows: false,
                pagination: false,
                interval: 3000,
                breakpoints: {
                  1260: {
                    height: "400px",
                  },
                  810: {
                    height: "250px",
                  },
                  400: {
                    height: "150px",
                  },
                },
              }}
            >
              <SplideSlide>
                <img src="./Images/Sliders/slide-1.jpg" alt="slide1" />
              </SplideSlide>
              <SplideSlide>
                <img src="./Images/Sliders/slide-2.jpg" alt="slide2" />
              </SplideSlide>
            </Splide>
          </div>
        </div>
        <div className="ctn-content">
          <div className="ctn-info-mobile">
            <h1 className="main-title">
              Généralité <span className="title-anchor">Informatique</span>
            </h1>
            <p>
              La GI (Généralité informatique) est une entreprise spécialisée
              dans les domaines : ventes et installation des caméras vidéo...
            </p>
            <div className="btn-ctn">
              <button className="btn-btn-link">
                <Link to="/contact">Nous Contactez</Link>
              </button>
              <button className="btn-btn-link-flat">
                <Link to="/about">Voir Plus</Link>
              </button>
            </div>
            <h1 className="t-center t-element">À propos de :</h1>
          </div>
        </div>

        <div
          className="service-ctn-principal ctn-content"
          data-aos={`${matches ? "none" : "zoom-in-up"}`}
          data-aos-delay={`${matches ? "none" : 200}`}
        >
          <div className="service-ctn">
            <a className="service-item" href="#nos-missions">
              <Logo name="Nos Missions" />
              <h3>Nos Missions</h3>
              <h2>
                fournir des équipements de surveillance et de sécurité
                informatique de haute qualité à ses clients, tout en offrant un
                service de maintenance fiable et efficace.
              </h2>
            </a>
            <a className="service-item" href="#nos-services">
              <Logo name="Nos Services" />
              <h3>Nos Services</h3>
              <h2>
                vente et la maintenance d'équipements de surveillance et de
                sécurité informatique, ainsi que la conception de chartes
                graphiques.
              </h2>
            </a>
            <a className="service-item" href="#nos-activites">
              <Logo name="Nos activites" />
              <h3>Nos Activités</h3>
              <h2>Surveillance, sécurité informatique et maintenance</h2>
            </a>
            <Link className="service-item" to="/contact">
              <Logo name="Vos sugesstion" />
              <h3>Vos sugesstion</h3>
              <h2>
                Si vous êtes intéressé par les services de surveillance,
                sécurité informatique, maintenance ou charte graphique,
                n'hésitez pas à contacter Généralité Informatique pour obtenir
                des conseils et des solutions adaptées à vos besoins.
              </h2>
            </Link>
          </div>
        </div>
        <div className="ctn-content">
          <h1 className="t-element">Notre Réputation</h1>
          <p className="t-center">
            Faites confiance par des meilleurs entreprises du cameroun :{" "}
          </p>
        </div>
        <SocialProofContainer />
        <div className="ctn-content">
          <div className="ctn-vente">
            <div className="t-dventes">
              <h1 className="head-title">Nos produits en ventes</h1>
              <p>
                Consulter la liste de nos produits de qualités superieures qui
                defis toutes concurences.
              </p>
              <div className="listCategories">
                {!loading ? (
                  <>
                    {categories.map((c) => (
                      <NavLink key={c.id} to={`/ventes?cat=${c.name}`}>
                        {c.name}
                      </NavLink>
                    ))}
                  </>
                ) : (
                  <>
                    <Skeleton
                      className="loading"
                      animation="wave"
                      width={120}
                      height={55}
                      sx={{
                        borderRadius: "20px",
                      }}
                    />
                    <Skeleton
                      animation="wave"
                      width={100}
                      height={55}
                      sx={{
                        borderRadius: "20px",
                      }}
                    />
                  </>
                )}
              </div>
              <button className="btn-btn-link">
                <Link to="/ventes">Voir les Produits</Link>
              </button>
            </div>
            <div className="l-produits">
              {!loading ? (
                <Splide
                  aria-label="Vente"
                  options={{
                    type: "loop",
                    Width: "100%",
                    height: `300px`,
                    fixedHeight: false,
                    autoplay: true,
                    arrows: true,
                    pagination: true,
                    interval: 3000,
                    breakpoints: {
                      600: {
                        height: "240px",
                      },
                    },
                  }}
                >
                  {products.map((product) => (
                    <SplideSlide className="slide-product">
                      <img src={product.imageProd} alt={product.nameProd} />
                    </SplideSlide>
                  ))}
                </Splide>
              ) : (
                <Skeleton
                  variant="rectangular"
                  className="placeholderProduct"
                  sx={{
                    width: "100%",
                    borderRadius: "10px",
                    margin: "10px 0",
                  }}
                />
              )}
            </div>
          </div>
          <div className="infoService-ctn">
            <div className="iservice-ctn" id="nos-missions">
              <div className="iservice-img">
                <BlurryImage
                  className="cover"
                  alt="image1"
                  imageUrl={"Images/services-images/maintenance (3).jpg"}
                />
              </div>
              <div className="iservice-d">
                <b>NOS MISSIONS</b>
                <p>
                  la sécurité et la surveillance, offrant une gamme complète de
                  produits et de services. Elle vend une variété d'équipements
                  de surveillance tels que des caméras.
                </p>
                <button className="btn-btn-link">
                  <Link to="/contact">Nous Contactez</Link>
                </button>
              </div>
            </div>
            <div className="iservice-ctn" id="nos-services">
              <div className="iservice-img">
                <BlurryImage
                  className="cover"
                  alt="image2"
                  imageUrl={"./Images/services-images/maintenance-2.jpg"}
                />
              </div>
              <div className="iservice-d">
                <b>NOS SERVICES</b>
                <p>
                  la vente, la maintenance et la conception de solutions de
                  sécurité et de surveillance. Elle propose une gamme de
                  produits et de services pour répondre aux besoins de ses
                  clients, notamment des équipements de surveillance tels que
                  des caméras, fournitures de bureau.
                </p>
                <button className="btn-btn-link">
                  <Link to="/contact">Nous Contactez</Link>
                </button>
              </div>
            </div>
            <div className="iservice-ctn" id="nos-activites">
              <div className="iservice-img">
                <BlurryImage
                  className="cover"
                  alt="image3"
                  imageUrl={"./Images/services-images/maintenance-3.jpg"}
                />
              </div>
              <div className="iservice-d">
                <b>NOS ACTIVITES</b>
                <p>
                  {" "}
                  les activités de sécurité et de surveillance. Elle propose une
                  large gamme de produits et de services pour répondre aux
                  besoins de ses clients, tels que la vente et la maintenance
                  d'équipements de surveillance tels que des caméras.
                </p>
                <button className="btn-btn-link">
                  <Link to="/contact">Nous Contactez</Link>
                </button>
              </div>
            </div>
          </div>
          <div className="testimonial">
            <h1 className="t-center t-element">Temoignages</h1>
            <p className="t-center">
              Les gens aiment ce que nous faisons et veulent le faire savoir
            </p>
          </div>
        </div>
        <div className="testimonial opt-content">
          <div className="ctn-testimonials">
            <Splide
              aria-label="testimonial"
              options={{
                type: "loop",
                Width: "100%",
                fixedHeight: false,
                autoplay: true,
                arrows: false,
                pagination: true,
                interval: 3000,
                perPage: 1,
              }}
            >
              <SplideSlide className="slide-testimonial">
                <p>
                  J'ai acheté un système de caméra de surveillance à GI pour
                  protéger ma maison. Leur équipe a été très utile pour m'aider
                  à choisir le bon système pour mes besoins, et ils ont fourni
                  une installation professionnelle et rapide. Le système
                  fonctionne très bien et je me sens beaucoup plus en sécurité
                  chez moi grâce à GI.
                </p>
                <div className="autor">
                  <strong>Moussa</strong>-<span>commercant</span>
                </div>
              </SplideSlide>
              <SplideSlide className="slide-testimonial">
                <p>
                  En tant que responsable de la sécurité d'un immeuble
                  résidentiel, j'ai travaillé avec GI pour installer un système
                  de surveillance complet. Leur équipe a été très
                  professionnelle et compétente, et ils ont géré tout le
                  processus avec diligence et efficacité. Le système de
                  surveillance qu'ils ont installé a fonctionné de manière
                  fiable et efficace depuis son installation, et je suis très
                  satisfait de leur travail.
                </p>
                <div className="autor">
                  <strong>Aliou</strong>-<span>Gerant Immeuble</span>
                </div>
              </SplideSlide>
              <SplideSlide className="slide-testimonial">
                <p>
                  Je suis un propriétaire d'entreprise qui avait besoin d'une
                  charte graphique professionnelle pour mon site web et mes
                  documents marketing. GI a été recommandé par un ami et je suis
                  très heureux de les avoir choisis. Leur équipe de designers
                  graphiques a travaillé en étroite collaboration avec moi pour
                  comprendre mes besoins et mes préférences, et ils ont créé une
                  charte graphique qui correspondait parfaitement à l'image de
                  marque de mon entreprise. Je suis vraiment satisfait de leur
                  travail.
                </p>
                <div className="autor">
                  <strong>Kouyabe</strong>-<span>Directeur</span>
                </div>
              </SplideSlide>
              <SplideSlide className="slide-testimonial">
                <p>
                  Je travaillais dans une entreprise qui avait besoin d'une mise
                  à jour de son système de surveillance et de sécurité
                  informatique. Nous avons contacté GI pour obtenir de l'aide et
                  ils ont été fantastiques. Leur équipe a conçu une solution sur
                  mesure pour répondre à nos besoins, et leur service
                  après-vente a été incroyable. Je recommande vivement GI à
                  toute entreprise qui a besoin d'un système de sécurité fiable
                  et efficace.
                </p>
                <div className="autor">
                  <strong>Bachir</strong>-<span>Employé</span>
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
